import { render } from "./SolutionSection.vue?vue&type=template&id=bb7ec36c&scoped=true"
import script from "./SolutionSection.vue?vue&type=script&lang=js"
export * from "./SolutionSection.vue?vue&type=script&lang=js"

import "./SolutionSection.vue?vue&type=style&index=0&id=bb7ec36c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7ec36c"]])

export default __exports__